import { LuArrowRight, LuSearch } from 'react-icons/lu';
import styles from '../styles.module.scss';

type ActionSectionProps = {
    onDetailAssessment: () => void;
};

export const ActionSection = ({ onDetailAssessment }: ActionSectionProps) => {
    return (
        <section className={styles.actionSection}>
            <span className={styles.actionLabel}>もっと正確な金額を知りたい方へ</span>

            <div className={styles.detailCard}>
                <div className={styles.detailTop}>
                    <div className={styles.detailIconWrap}>
                        <LuSearch />
                    </div>
                    <div className={styles.detailDesc}>
                        <h3 className={styles.detailTitle}>くわしく査定で、より正確な金額を確認</h3>
                        <p className={styles.detailText}>
                            物件の詳細情報をご入力いただくと、より精度の高い査定額を算出します。
                            <br />
                            もちろん無料でご利用いただけます。
                        </p>
                    </div>
                </div>

                <button type="button" className={styles.detailBtn} onClick={onDetailAssessment}>
                    くわしく査定へすすむ
                    <LuArrowRight className={styles.detailBtnIcon} />
                </button>
            </div>
        </section>
    );
};
